export type PublishedStatusType = "draft" | "published" | "not published" | "";

export default class PublishedStatusTypes {
  static draft: PublishedStatusType = "draft";
  static published: PublishedStatusType = "published";
  static notPublished: PublishedStatusType = "not published";
  static empty: PublishedStatusType = "";

  static ConvertToPublishedStatusType(
    status: boolean | string | undefined,
    hasBeenPublished?: boolean,
  ): PublishedStatusType {
    const isStatusInvalid = status === undefined || status === "";

    if (isStatusInvalid) {
      return this.empty;
    }

    const isPublishedStatus = status === true || status === this.published;
    const isDraftStatus = !status || status === this.draft;
    const isNotPublishedStatus = hasBeenPublished === false && isDraftStatus;

    if (isNotPublishedStatus) {
      return this.notPublished;
    } else if (isPublishedStatus) {
      return this.published;
    } else if (isDraftStatus) {
      return this.draft;
    } else {
      return this.empty;
    }
  }
}
